export function isServiceSegment(
  item?: ProposalSegment | Partial<ProposalSegment & Record<'id', string>>,
): item is ServiceSegment {
  return item?.type === 'service';
}
